import { Link } from "react-router-dom";
import { Card, CardContent } from "../../client/components/ui/card";

interface BlogCardProps {
  post: {
    slug: string;
    title: string;
    excerpt?: string | null;
    coverImageUrl?: string | null;
    publishedAt?: Date | string | null;
    authorName: string;
    tags: string[];
    category?: { name: string; slug: string } | null;
  };
}

export default function BlogCard({ post }: BlogCardProps) {
  const formattedDate = post.publishedAt
    ? new Date(post.publishedAt).toLocaleDateString("fr-FR", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;

  return (
    <Link to={`/blog/${post.slug}`} className="group block">
      <Card className="h-full overflow-hidden transition-all duration-200 hover:border-primary/40 hover:shadow-lg hover:shadow-primary/5">
        {post.coverImageUrl && (
          <div className="aspect-video overflow-hidden">
            <img
              src={post.coverImageUrl}
              alt={post.title}
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          </div>
        )}
        <CardContent className="p-5">
          <h2 className="font-semibold text-foreground text-lg leading-snug mb-2 group-hover:text-primary transition-colors line-clamp-2">
            {post.title}
          </h2>
          {post.excerpt && (
            <p className="text-muted-foreground text-sm leading-relaxed line-clamp-3 mb-4">
              {post.excerpt}
            </p>
          )}
          <div className="flex items-center justify-between text-xs text-muted-foreground mt-auto">
            <div className="flex items-center gap-2">
              <span>{post.authorName}</span>
              {post.category && (
                <span className="text-muted-foreground/60">· {post.category.name}</span>
              )}
            </div>
            {formattedDate && <span>{formattedDate}</span>}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
